import { guardAdminOnly } from "@/lib/auth/routeGuards"
/**
 * Exam Timetable Route
 * Follows the same pattern as /admin/timetable.tsx
 */
import { createFileRoute } from '@tanstack/react-router'
import ExamTimetableManagement from '@/components/adminPage/examTimetable/ExamTimetableManagement'

export const Route = createFileRoute('/admin/exam-timetable')({
  beforeLoad: guardAdminOnly,
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="">
      <ExamTimetableManagement />
    </div>
  )
}
